export function pt2px(points: number, dpi = 96) {
  return (points * dpi) / 72
}
